import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

const AddSubstageArea = ({ currentStage, onAddSubstage, onOpenFilteringSubstagePopup }) => {
  const { t } = useTranslation('applicants');
  const { isRTL } = useLanguage();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  // For stage-1 (Hiring Process), show simplified "Add Step" button
  if (currentStage === 'stage-1') {
    return (
      <div 
        ref={dropdownRef}
        style={{
          position: 'relative',
          minWidth: '160px',
          maxWidth: '160px'
        }}
      >
        <button
          data-tutorial="add-step-button"
          ref={buttonRef}
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            setDropdownPos({ top: rect.bottom + 8, left: rect.left, width: rect.width });
            setIsDropdownOpen((prev) => !prev);
          }}
          className="post-job-cta"
          style={{ width: '100%', justifyContent: 'center', direction: isRTL ? 'rtl' : 'ltr' }}
        >
          <i className="fa-solid fa-circle-plus"></i>
          <span>{t('addSubstage.addStep')}</span>
        </button>
        
        {isDropdownOpen && (
          <div
            ref={dropdownRef}
            data-tutorial="add-step-dropdown"
            style={{
              position: 'fixed',
              top: `${dropdownPos.top}px`,
              left: `${dropdownPos.left}px`,
              width: `${dropdownPos.width}px`,
              backgroundColor: '#FFFFFF',
              borderRadius: '8px',
              boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
              zIndex: 10000,
              overflow: 'hidden'
            }}
          >
            <div
              onClick={() => {
                navigate('/new-interview-step');
                setIsDropdownOpen(false);
              }}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                color: "var(--app-neutral-ink, #000000)",
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              {t('addSubstage.addInterview')}
            </div>
            <div
              onClick={() => {
                navigate('/new-assessment-step');
                setIsDropdownOpen(false);
              }}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                color: "var(--app-neutral-ink, #000000)",
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              {t('addSubstage.addAssessment')}
            </div>
          </div>
        )}
      </div>
    );
  }

  // Only stage-1 is supported now
  return null;
};

export default AddSubstageArea; 
